import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Select, ValueButton } from "@activecollab/components";
import PropTypes from "prop-types";

export const MyGroupedByPicker = ({ groupedBy, onChange }) => {
  const { t } = useTranslation();

  const groups = useMemo(() => {
    return [
      {
        id: "start_date",
        name: t("By Start Date"),
      },
      {
        id: "date",
        name: t("By Due Date"),
      },
      {
        id: "project",
        name: t("By Project"),
      },
    ];
  }, [t]);

  const labelText = useMemo(() => {
    return groups.find((group) => group.id === groupedBy)?.name || t("By Project");
  }, [groupedBy, groups, t]);

  const [open, setOpen] = useState(false);
  const onSelectOpen = useCallback(() => setOpen(true), []);
  const onSelectClose = useCallback(() => setOpen(false), []);

  return (
    <div className="my_tasks_group_by_wrapper tw-flex">
      <Select
        options={groups}
        target={
          <ValueButton
            active={open}
            value={labelText}
            label={t("Group")}
          />
        }
        onChange={onChange}
        selected={groupedBy}
        forceCloseMenu
        disableSearch
        keepSameOptionsOrder
        onSelectOpen={onSelectOpen}
        onSelectClose={onSelectClose}
        position="bottom-end"
        disabledInternalSort
      />
    </div>
  );
};

MyGroupedByPicker.propTypes = {
  groupedBy: PropTypes.string,
  onChange: PropTypes.func,
};

MyGroupedByPicker.defaultProps = {
  groupedBy: "project",
  onChange: () => null,
};
